import React from "react";
import Ellipses from "../../components/Ellipses";
import BaseButton from "../../components/BaseButton";
import ExitModal from "../../modals/ExitModal";
import useController from "./controller";
import WrapperPage from "../../components/WrapperPage";
import { useTranslation } from "react-i18next";
import GameAuthor2 from "../../components/GameAuthor2";
import Butterflies from "../../components/Butterflies";
import "./style.scss";
import { isPWA, isWebView } from "../../utils/helpers";

export default function GreetingsPage() {
  const { navigateByRules, navigateToAppPage } = useController();

  const { t } = useTranslation();
  return (
    <div className="greeting-wrapper centering-page">
      <Ellipses className="greeting-wrapper-ellipses" countEllipses={1} />
      <Butterflies className="greeting-wrapper-butterflies" countEllipses={2} />
      <ExitModal />
      <WrapperPage backBtn burgerMenu>
        <section className="greeting-wrapper__main-info">
          <div className="greeting-wrapper__main-info__description">
            <div
              className="greeting-wrapper__title neon-text"
              data-text={t("greeting_page.title")}
            >
              {t("greeting_page.title")}
            </div>
            <div className="greeting-wrapper__subtitle">
              {t("greeting_page.subtitle")}
            </div>
            <div className="greeting-wrapper__main-info__description__text">
              <p>{t("greeting_page.description.desc1")}</p>
            </div>

            {isWebView() || isPWA() ? (
              <div className="greeting-wrapper__action-variants">
                <BaseButton
                  className="greeting-wrapper__action-variants--stay"
                  onClick={navigateByRules}
                >
                  {t("next")}
                </BaseButton>
              </div>
            ) : (
              <div className="greeting-wrapper__action-variants">
                <BaseButton
                  className="greeting-wrapper__action-variants--download"
                  onClick={navigateToAppPage}
                >
                  {t("download_app")}
                </BaseButton>
                <BaseButton
                  unfilledWhite
                  className="greeting-wrapper__action-variants--stay"
                  onClick={navigateByRules}
                >
                  {t("stay_on_site")}
                </BaseButton>
              </div>
            )}
          </div>
          <GameAuthor2 className="greeting-wrapper__main-info__author-avatar" />
        </section>
      </WrapperPage>
    </div>
  );
}
